import { xyz_n_1of6_lists, xyz_n_4of6, xyz_n_1of6, tLab } from './SL00000Sprint00'
import { orderedListSlide, tDiscussionBreakout, breakoutStandard } from './SLSprint00'

import { checklistAnnouncementsPreworkAndAgenda } from './SL00000Sprint00'
import { tPrework } from './SLSprint00'
import { completeDeck } from './SL00000Sprint00'

import { list20000Sprint06 } from '../ActivityLists/AL20000Sprint06'
import { list20000Sprint07 } from '../ActivityLists/AL20000Sprint07'

import { tMidtermExamExpectations, tExam } from './SLSprint00'

// import { tExamExpectations, tExam } from './SLSprint00'
import { basicSlide } from './SLSprint00'
import { bulletListSlide } from './SLSprint00'
// import { tNoClassToday } from './SL00000Sprint00'

// Todo:
//		'YouTube, Eric’s Trip to Google, The Social Dilemma, and Technology Business Models',
// theSocialDilemma, 
// Introduction to Computer Science (ICS) sprint 7 global values.

const sprint = 7
const activityListPrevious = () => { return list20000Sprint06(sprint-1) } 
const activityList = () => { return list20000Sprint07(sprint) }

// Session 1 of 6: Monday
export const sprint7PlanningExpectations = () => {
	return orderedListSlide('Sprint Planning as a Class', `Sprint ${sprint} Expectations:`, [
		'Similar to previous sprints in that it has a Discussion, Quiz, Lab, and Reflection',
		'Nearly 100% focused on your Class Project',
		`Sprint ${sprint} has an extra week making it three weeks duration`,
		'We missed part of a week due to Thanksgiving break',
		'Pulling forward effort from sprint 8 to make sprint 8 more manageable for you (18+18 -> ~32+4)',
		'Our Final Exam will be in person on Monday, December 1st with in person attendance required',
		`Sprint ${sprint+1} is directly connected with sprint ${sprint} in that we will be presenting our Class Projects` ])
}

export const ics_7_1of6_PAaA = xyz_n_1of6_lists(sprint)
export const ics_7_1of6 = () => { return xyz_n_1of6(sprint, ics_7_1of6_PAaA.prework, activityListPrevious, ics_7_1of6_PAaA.agenda, ics_7_2of6_PAaA.prework, activityList, sprint7PlanningExpectations) }

// Sprint 7 session 2 of 6: Wednesday
export const ics_7_2of6 = () => { return xyz_n_1of6(sprint, ics_7_1of6_PAaA.prework, activityListPrevious, ics_7_1of6_PAaA.agenda, ics_7_2of6_PAaA.prework, activityList, sprint7PlanningExpectations) }

// Sprint 7 session 3 of 6: Friday
const ics_7_2of6_PAaA = {
	'prework':[
		'Complete through activity 6 prior to next class', '',
		`Be prepared Discussion Board ${sprint}`,
		'Be prepared for Lab & Programming Together' ],
	'announcements':[ 
		'Review Final Exam date/time',
		'Review Class Project presentation data/time' ],
	'agenda':[
		`Discussion Board ${sprint} as a scrum team`,
		'Review Demo Schedule for Next Class',
		'Prework for Next Class',
		'Lab & Programming Together' ]
}
export const reviewDemoSchedule = () => {
	return bulletListSlide('Review Monday’s Demo Schedule', 
		'Let’s review Wednesday’s demo schedule while recalling that demos are an important part of scrum and that they:', [
		'Occur at the beginning of each new sprint ',
		'Are an opportunity to show what was completed in the previous sprint',
		'Are an **easy** and hopefully rewarding experience to show off your work',
		'Provide a chance to see how others solved a problem and to see some of the challenges they faces' ]
	)
}
export const ics_7_3of6 = () => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(ics_7_2of6_PAaA, sprint, activityList)
	const discussionBreakout = () => { return tDiscussionBreakout(sprint) } 
	const preworkNext = () => { return tPrework('Prework For Next Class', ics_7_3of6_PAaA.prework, sprint, activityList) }

	return completeDeck(slideDeck, [ discussionBreakout, preworkNext, reviewDemoSchedule, tLab ])
}

// Session 3 of 6: Friday
const ics_7_3of6_PAaA = {
	'prework':[
		'Complete through activity 7 prior to next class', '',
		'Be prepared for Demos & Retrospectives' ],
	'announcements':[ 
		'Final Exam: Verify you have your calendars marked for your Final Exam Date and Time',
		'Class Project Presentation: Verify you have your calendars marked for your Class Project presentation Date and Time' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		'Lab' ]
}


// Sprint 7 session 4 of 6: Monday
const ics_7_4of6_PAaA = {
	'prework':[
		'Complete through activity 8 prior to next class', '',
		'Be prepared to discuss Security',
		'Be prepared Lab' ],
	'announcements':[ 
		'Monday is our Final Exam (in-person attendance required) **', '',
		'Final Exam: Verify your calendar is marked',
		'Class Project Presentation: Verify your calendar is marked' ],
	'agenda':[
		'Sprint Progress Polling',
		'Breakout on Security',
		'Lab' ]
}
export const ics_7_4of6 = () => {
	const breakout = () => { 
		return breakoutStandard( 
			'Breakout: Security', 
			'In this breakout session we will explore Security:', [
				'Information Security and Confidentiality, Availability, and Integrity',
				'Access, Authentication, Authorization, CAPTCHA',
				'Malicious Code, Malware, Worms, Trojan Horses, Phishing, and DoS',
				'Cryptography, Encryption/Decryption, ciphers, public-key cryptography, and digital signatures',
				'Protecting Online Information',
				'Security and Usability Tradeoffs' ]
		)
	}
	return xyz_n_4of6(sprint, ics_7_4of6_PAaA, ics_7_5of6_PAaA.prework, activityList, breakout)
}

// Sprint 7 session 5 of 6: Wednesday
const ics_7_5of6_PAaA = {
	'prework':[
		'Be prepared for your Final Exam' ],
	'announcements':[ 
		'Review Final Exam date/time',
		'Review Class Project presentation data/time' ],
	'agenda':[
		'Sprint Progress Polling',
		'Breakout on Security',
		'Lab' ]
}
export const ics_7_5of6 = () => {
	const breakout = () => { 
		return breakoutStandard( 
			'Breakout: Security', 
			'In this breakout session we will explore Security:', [
				'Information Security and Confidentiality, Availability, and Integrity',
				'Access, Authentication, Authorization, CAPTCHA',
				'Malicious Code, Malware, Worms, Trojan Horses, Phishing, and DoS',
				'Cryptography, Encryption/Decryption, ciphers, public-key cryptography, and digital signatures',
				'Protecting Online Information',
				'Security and Usability Tradeoffs' ]
		)
	}
	return xyz_n_4of6(sprint, ics_7_5of6_PAaA, ics_7_6of6_PAaA.prework, activityList, breakout)
}

// Sprint 7 session 6 of 6: Friday
const ics_7_6of6_PAaA = {
	'prework':[
		'Complete through activity 8 prior to next class',
		'Be prepared for discussion on Social Media' ],
	'announcements':[ 
		'Review Final Exam date/time',
		'Review Class Project presentation data/time' ],
	'agenda':[
		'Optional Lab',
		'Breakout ons Social Media and Technology Business Models',
		'Social Media, YouTube, and Technology Business Models' ]
}
export const breakoutSocialMedia = () => { 
	return breakoutStandard( 
		'Breakout: Social Media, YouTube, and Technology Business Models', 
		'In this breakout session we will explore:', [
			'Social Media, YouTube, and Technology Business Models',
			'YouTube, Eric’s Trip to Google, The Social Dilemma, and Technology Business Models']
	)
}
export const isItPossibleTo = () => {
		return orderedListSlide('Software Business Models and YouTube',
		'Software Business Models, YouTube, and the competition for your eyes', [
			'Is is possible for me to use YouTube and at the same time “protect” your focus?',
			'If so, what can I do to make that happen?' ])
	}
export const ics_7_6of6 = () => { 
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(ics_7_6of6_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', ics_7_7of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ tLab, preworkNext, breakoutSocialMedia, isItPossibleTo ])
}

// Sprint 7 session 7 of 6: Monday
export const ics_7_7of6_PAaA = {
	'prework':[
		'Be prepared for Final Exam' ],
	'announcements':[
		'Wednesday will be sprint 8 planning',
		'Wednesday will also be “Globalization, Software Development, and Working with India”' ],
	'agenda': [ 
		'Review Class Project presentation Date, Time, and Expectations',
		'Final Exam' ]
}
export const confirmFinalExamAndPresentationTimes = () => {
	return orderedListSlide('Confirm Final Exam and Class Project presentation times',
		'Sprint 8 Planning and Class Project Presentation, Dates and Times', [
		'Sprint 8 Planning',
		'Confirm Class Project Presentation (in-person attendance required)' ] )
}
export const ics_7_7of6 = () => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(ics_7_7of6_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', ics_7_8of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ confirmFinalExamAndPresentationTimes, preworkNext, tMidtermExamExpectations, tExam ]) 
}

export const workingWithIndia = () => {
	return orderedListSlide('Globalization and Working with India', 
		'Globalization, Software Development, and Working with India', [ ] )
}

// Sprint 7 session 8 of 6: Wednesday
const ics_7_8of6_PAaA = {
	'prework': [ 
		'Be prepared for Final Exam'],
	'announcements': [
		`All sprint ${sprint} assignments due Sunday`,
		`All sprint ${sprint+1} assignment two hours before your Class Project Presentation` ],
	'agenda': [ 
		'Review Class Project presentation Date, Time, and Expectations',
		'Final Exam' ]
}

export const confirmPresentationTimes = () => {
	return orderedListSlide('Confirm Class Project Presentation Date and Time',
		'Confirm Class Project Presentation Date and Time', [ ] )		
}
export const finalProjectPresentation = () => {
	return orderedListSlide('Class Project Presentation Expectations ', `Recall that your final project presentation should including a/an:`, [
		'Introduce of your yourself',
		'An overview of your Class Project Proposal including which features are completed',
		'A demonstration of your product focusing on the greater in complexity features delivered',
		'A review of the code highlighting the greater in complexity features and explaining your implementation',
		'A description what you would do next if you had more time to work on the project' ])
}
export const ics_7_8of6 = () => { 
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(ics_7_8of6_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', ics_7_9of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ confirmPresentationTimes, finalProjectPresentation, preworkNext, tMidtermExamExpectations, tExam ]) 
}

export const ics_7_9of6_PAaA = { 
	'prework':[
		'Be prepared for Sprint 8 Planning',
		`Be prepared for Lab` ],
	'announcements':[
		`All sprint ${sprint} assignments due Sunday`,
		`All sprint ${sprint+1} assignment due two hours before your Class Project Presentation` ],
	'agenda':[
		'Review Class Project presentation Date, Time, and Expectations',
		`Final review of sprint ${sprint} and sprint ${sprint+1} assignments` ]
}
export const ics_7_9of6 = () => { 
	const sprint8Planning = () => {
	return orderedListSlide('Sprint Planning', `Sprint ${sprint+1} Expectations:`, [
		'Sprint 8 is all about presenting your Class Project',
		'Submit Lab 8 at least two hours prior to your schedule Class Project Presentation time',
		'No assignments will be accepted after Wednesday' ])
}
	const finalReviewActivityListAndAssignments = () => { return basicSlide(
		`Final sprint ${sprint} and ${sprint+1} activity list and assignment Q&A`, [`Any sprint ${sprint} activity list or assignment questions?`]) }
	const nextSteps = () => { return tPrework('Next Steps', [ 
		`All sprint ${sprint} assignments due Sunday`,
		'Remaining Class Project presentations next week Monday by 8:30 am CT'], 
		sprint, activityList) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(ics_7_9of6_PAaA, sprint, activityList)
	return completeDeck(slideDeck, [ sprint8Planning, finalProjectPresentation, finalReviewActivityListAndAssignments, nextSteps ]) 
}
